module.exports = __webpack_public_path__ + "img/report-attend.6317395f.svg";